<ng-container *ngIf="page">
  <ng-container *ngIf="brConfig?.fundId; else previewBlock">
    <div class="block-body fund-documents" id="fund-docs-section">
      <h4 class="small-title"> {{ "products.fund-documents" | translate }}</h4>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <button class="nav-link active" id="nav-documents-tab" data-bs-toggle="tab" data-bs-target="#nav-documents"
                type="button" role="tab" aria-controls="nav-documents"
                aria-selected="true">{{ "products.fund-documents" | translate }}
        </button>
        <button *ngIf="fundDocuments && hasDocuments('Dis-Portfolio-Monthly')" class="nav-link"
                id="monthly-documents-tab" data-bs-toggle="tab" data-bs-target="#monthly-documents"
                type="button" role="tab" aria-controls="monthly-documents"
                aria-selected="false">{{ "products.disclosure-of-portfolios-monthly" | translate }}
        </button>
        <button *ngIf="fundDocuments && hasDocuments('Dis-Portfolio-Halfyearly')" class="nav-link"
                id="yearly-documents-tab" data-bs-toggle="tab" data-bs-target="#yearly-documents"
                type="button" role="tab" aria-controls="yearly-documents"
                aria-selected="false">{{ "products.disclosure-of-portfolios-half-yearly" | translate }}
        </button>
        <button *ngIf="fundDocuments && hasDocuments('Dis-Portfolio-Fortnightly')" class="nav-link"
                id="fortnightly-documents-tab" data-bs-toggle="tab"
                data-bs-target="#fortnightly-documents" type="button" role="tab" aria-controls="fortnightly-documents"
                aria-selected="false">{{ "products.disclosure-of-portfolios-fortnightly" | translate }}
        </button>
      </div>
      <div class="inner-container padding-box">
        <div class="tab-content" id="nav-tabContent">
          <div class="tab-pane fade show active" id="nav-documents" role="tabpanel" aria-labelledby="nav-documents-tab"
               tabindex="0">
            <div class="scroll-container" *ngIf="fundDocuments && fundDocuments.length">
              <div *ngFor="let documentCategory of fundDocuments" class="row">
                <ng-container *ngIf="documentCategory.fundDocCategory === 'FUND-DOCUMENTS'">
                  <div *ngFor="let document of documentCategory.documents" class="col-md-6 col-12 mb-3">
                    <div class="update-box" style="cursor: pointer;">
                      <div (click)="downloadDocument(document)">
                        <img alt="Download The Document" [src]="'assets/images/home/'+document?.fileType?.toLowerCase()+'.svg'">
                        {{ "literature.custom-label-" + document.contentGrouping | translate }}
                      </div>
                      <a [href]="'download' + document.literatureHref" style="cursor: pointer;" target="_blank"><i aria-label="Download Fund Factsheet" class="bi bi-chevron-right"></i></a>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="text-center pt-3">
              <a [href]="'products.fund-documents-view-all-link' | translate" target="_blank">
                <span class="link-text view-dark">{{ "products.all_documents" | translate }}</span>
                <i class="bi bi-chevron-right"></i>
              </a>
            </div>
          </div>
          <div class="tab-pane fade" id="monthly-documents" role="tabpanel" aria-labelledby="monthly-documents-tab"
               tabindex="0">
            <div class="tab-form mb-4" style="margin-left:auto;">
              <div class="row gx-3">
                <div class="col">
                  <div class="date d-inline-block">
                    <div class="date-group bg-white d-inline-flex">
                      <input type="text" class="form-control date-field custom-input" placeholder="From"
                             [(ngModel)]="monthlyFromDate">
                      <ft-date-picker [displayDate]="monthlyFromDate" [convertToFormat]="'MMM YYYY'"
                                      [customLeftPosition]="'calc(50% - 100px)'"
                                      [sentDateFormat]="'MMM YYYY'" type="month"
                                      (finalDate)="onFinalDate($event, 'fromDate','monthly')"></ft-date-picker>
                    </div>
                  </div>

                </div>
                <div class="col">
                  <div class="date d-inline-block">
                    <div class="date-group bg-white d-inline-flex">
                      <input type="text" class="form-control date-field custom-input" placeholder="To"
                             [(ngModel)]="monthlyToDate">
                      <ft-date-picker [displayDate]="monthlyToDate" [convertToFormat]="'MMM YYYY'"
                                      [sentDateFormat]="'MMM YYYY'" type="month"
                                      (finalDate)="onFinalDate($event, 'toDate','monthly')"></ft-date-picker>
                    </div>
                  </div>
                </div>
                <div class="col-auto">
                  <button class="btn btn-primary"
                          (click)="fiterDocuments('Dis-Portfolio-Monthly')">{{ "products.submit-filter" | translate }}
                  </button>
                </div>
              </div>
            </div>
            <div class="scroll-container" *ngIf="fundDocuments && fundDocuments.length">
              <div
                  *ngIf="!filteredFundDocumentsMonthly || filteredFundDocumentsMonthly.length === 0; else filteredContentMon">
                <div *ngFor="let documentCategory of fundDocuments" class="row">
                  <ng-container *ngIf="documentCategory.fundDocCategory === 'Dis-Portfolio-Monthly'">
                    <div *ngFor="let document of documentCategory.documents" class="col-md-6 col-12 mb-3">
                      <div class="update-box" style="cursor: pointer;" >
                        <div (click)="downloadDocument(document)">
                          <img [alt]="'Download '+ document.dctermsTitle" [src]="'assets/images/home/'+document?.fileType?.toLowerCase()+'.svg'">
                          {{ document.dctermsTitle }}
                        </div>
                        <a [href]="'download' + document.literatureHref" style="cursor: pointer;" target="_blank"><i
                            class="bi bi-chevron-right"></i></a>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
              <ng-template #filteredContentMon>
                <!-- Display filteredFundDocumentsMonthly when filtering is applied and the filtered array is not empty -->
                <div *ngFor="let documentCategory of filteredFundDocumentsMonthly" class="row">
                  <ng-container *ngIf="documentCategory.fundDocCategory === 'Dis-Portfolio-Monthly'">
                    <ng-container
                        *ngIf="documentCategory.documents && documentCategory.documents.length > 0; else noDocumentsMessage">
                      <div *ngFor="let document of documentCategory.documents" class="col-md-6 col-12 mb-3">
                        <div class="update-box" style="cursor: pointer;">
                          <div (click)="downloadDocument(document)">
                            <img [alt]="'Download '+ document.dctermsTitle" [src]="'assets/images/home/'+document?.fileType?.toLowerCase()+'.svg'">
                            {{ document.dctermsTitle }}
                          </div>
                          <a [href]="'download' + document.literatureHref" target="_blank"><i class="bi bi-chevron-right"></i></a>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
                <ng-template #noDocumentsMessage>
                  <div class="text-center pt-3">
                    <p>{{ "products.no_filter_documents" | translate }}</p>
                  </div>
                </ng-template>
              </ng-template>
            </div>
            <div class="text-center pt-3">
              <a [href]="'products.fund-documents-monthly-view-all-link' | translate" target="_blank">
                <span class="link-text view-dark">{{ "products.all_documents_archive" | translate }}</span>
                <i class="bi bi-chevron-right"></i>
              </a>
            </div>
          </div>
          <div class="tab-pane fade" id="yearly-documents" role="tabpanel" aria-labelledby="yearly-documents-tab"
               tabindex="0">
            <div class="tab-form mb-4" style="margin-left:auto;">
              <div class="row gx-3">
                <div class="col">
                  <div class="date d-inline-block">
                    <div class="date-group bg-white d-inline-flex">
                      <input type="text" class="form-control date-field custom-input" placeholder="From"
                             [(ngModel)]="hyearlyFromDate">
                      <ft-date-picker [displayDate]="hyearlyFromDate" [convertToFormat]="'MMM YYYY'"
                                      [customLeftPosition]="'calc(50% - 100px)'"
                                      [sentDateFormat]="'MMM YYYY'" type="month"
                                      (finalDate)="onFinalDate($event, 'fromDate','hyearly')"></ft-date-picker>
                    </div>
                  </div>

                </div>
                <div class="col">
                  <div class="date d-inline-block">
                    <div class="date-group bg-white d-inline-flex">
                      <input type="text" class="form-control date-field custom-input" placeholder="To"
                             [(ngModel)]="hyearlyToDate">
                      <ft-date-picker [displayDate]="hyearlyToDate" [convertToFormat]="'MMM YYYY'"
                                      [sentDateFormat]="'MMM YYYY'" type="month"
                                      (finalDate)="onFinalDate($event, 'toDate','hyearly')"></ft-date-picker>
                    </div>
                  </div>
                </div>
                <div class="col-auto">
                  <button class="btn btn-primary"
                          (click)="fiterDocuments('Dis-Portfolio-Halfyearly')">{{ "products.submit-filter" | translate }}
                  </button>
                </div>
              </div>
            </div>
            <div class="scroll-container" *ngIf="fundDocuments && fundDocuments.length">
              <div
                  *ngIf="!filteredFundDocumentsHalfyearly || filteredFundDocumentsHalfyearly.length === 0; else filteredContentYearly">
                <div *ngFor="let documentCategory of fundDocuments" class="row">
                  <ng-container *ngIf="documentCategory.fundDocCategory === 'Dis-Portfolio-Halfyearly'">
                    <div *ngFor="let document of documentCategory.documents" class="col-md-6 col-12 mb-3">
                      <div class="update-box" style="cursor: pointer;">
                        <div (click)="downloadDocument(document)">
                          <img [alt]="'Download '+ document.dctermsTitle" [src]="'assets/images/home/'+document?.fileType?.toLowerCase()+'.svg'">
                          {{ document.dctermsTitle }}
                        </div>
                        <a [href]="'download' + document.literatureHref" target="_blank"><i class="bi bi-chevron-right"></i></a>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
              <ng-template #filteredContentYearly>
                <!-- Display filteredFundDocumentsHalfyearly when filtering is applied and the filtered array is not empty -->
                <div *ngFor="let documentCategory of filteredFundDocumentsHalfyearly" class="row">
                  <ng-container *ngIf="documentCategory.fundDocCategory === 'Dis-Portfolio-Halfyearly'">
                    <ng-container
                        *ngIf="documentCategory.documents && documentCategory.documents.length > 0; else noDocumentsMessage">
                      <div *ngFor="let document of documentCategory.documents" class="col-md-6 col-12 mb-3">
                        <div class="update-box" style="cursor: pointer;">
                          <div (click)="downloadDocument(document)">
                            <img [alt]="'Download '+ document.dctermsTitle" [src]="'assets/images/home/'+document?.fileType?.toLowerCase()+'.svg'">
                            {{ document.dctermsTitle }}
                          </div>
                          <a [href]="'download' + document.literatureHref" target="_blank"><i class="bi bi-chevron-right"></i></a>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
                <ng-template #noDocumentsMessage>
                  <div class="text-center pt-3">
                    <p>{{ "products.no_filter_documents" | translate }}</p>
                  </div>
                </ng-template>
              </ng-template>

            </div>
            <div class="text-center pt-3">
              <a [href]="'products.fund-documents-half-yearly-view-all-link' | translate" target="_blank">
                <span class="link-text view-dark">{{ "products.all_documents_archive" | translate }}</span>
                <i class="bi bi-chevron-right"></i>
              </a>
            </div>

          </div>
          <div class="tab-pane fade" id="fortnightly-documents" role="tabpanel"
               aria-labelledby="fortnightly-documents-tab"
               tabindex="0">
            <div class="tab-form mb-4" style="margin-left:auto;">
              <div class="row gx-3">
                <div class="col">
                  <div class="date d-inline-block">
                    <div class="date-group bg-white d-inline-flex">
                      <input type="text" class="form-control date-field custom-input" placeholder="From"
                             [(ngModel)]="fortnightlyFromDate">
                      <ft-date-picker [displayDate]="fortnightlyFromDate" [convertToFormat]="'MMM YYYY'"
                                      [customLeftPosition]="'calc(50% - 100px)'"
                                      [sentDateFormat]="'MMM YYYY'" type="month"
                                      (finalDate)="onFinalDate($event, 'fromDate','fortnightly')"></ft-date-picker>
                    </div>
                  </div>

                </div>
                <div class="col">
                  <div class="date d-inline-block">
                    <div class="date-group bg-white d-inline-flex">
                      <input type="text" class="form-control date-field custom-input" placeholder="To"
                             [(ngModel)]="fortnightlyToDate">
                      <ft-date-picker [displayDate]="fortnightlyToDate" [convertToFormat]="'MMM YYYY'"
                                      [sentDateFormat]="'MMM YYYY'" type="month"
                                      (finalDate)="onFinalDate($event, 'toDate','fortnightly')"></ft-date-picker>
                    </div>
                  </div>
                </div>
                <div class="col-auto">
                  <button class="btn btn-primary"
                          (click)="fiterDocuments('Dis-Portfolio-Fortnightly')">{{ "products.submit-filter" | translate }}
                  </button>
                </div>
              </div>
            </div>
            <div class="scroll-container" *ngIf="fundDocuments && fundDocuments.length">
              <div
                  *ngIf="!filteredFundDocumentsFortnightly || filteredFundDocumentsFortnightly.length === 0; else filteredContentFortnightly">
                <div *ngFor="let documentCategory of fundDocuments" class="row">
                  <ng-container *ngIf="documentCategory.fundDocCategory === 'Dis-Portfolio-Fortnightly'">
                    <div *ngFor="let document of documentCategory.documents" class="col-md-6 col-12 mb-3">
                      <div class="update-box" style="cursor: pointer;">
                        <div (click)="downloadDocument(document)">
                          <img [alt]="'Download '+ document.dctermsTitle" [src]="'assets/images/home/'+document?.fileType?.toLowerCase()+'.svg'">
                          {{ document.dctermsTitle }}
                        </div>
                        <a [href]="'download' + document.literatureHref" target="_blank"><i class="bi bi-chevron-right"></i></a>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
              <ng-template #filteredContentFortnightly>
                <!-- Display filteredFundDocumentsFortnightly when filtering is applied and the filtered array is not empty -->
                <div *ngFor="let documentCategory of filteredFundDocumentsFortnightly" class="row">
                  <ng-container *ngIf="documentCategory.fundDocCategory === 'Dis-Portfolio-Fortnightly'">
                    <ng-container
                        *ngIf="documentCategory.documents && documentCategory.documents.length > 0; else noDocumentsMessage">
                      <div *ngFor="let document of documentCategory.documents" class="col-md-6 col-12 mb-3">
                        <div class="update-box" style="cursor: pointer;">
                          <div (click)="downloadDocument(document)">
                            <img [alt]="'Download '+ document.dctermsTitle" [src]="'assets/images/home/'+document?.fileType?.toLowerCase()+'.svg'">
                            {{ document.dctermsTitle }}
                          </div>
                          <a [href]="'download' + document.literatureHref" target="_blank"><i class="bi bi-chevron-right"></i></a>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
                <ng-template #noDocumentsMessage>
                  <div class="text-center pt-3">
                    <p>{{ "products.no_filter_documents" | translate }}</p>
                  </div>
                </ng-template>
              </ng-template>
            </div>
            <div class="text-center pt-3">
              <a [href]="'products.fund-documents-fortnightly-view-all-link' | translate" target="_blank">
                {{ "products.all_documents_archive_fortnightly" | translate }} <i class="bi bi-chevron-right"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #previewBlock>
  <h5 *ngIf="page && page.isPreview()">Fund Documents Component</h5>
</ng-template>
